/**
 * components/SuggestionsPanel.tsx - Suggestions Panel Component
 * 
 * CHANGE HISTORY:
 * - 251103_1047 [pending] danielbeer: Initial SuggestionsPanel component
 * 
 * Displays auto-match suggestions for user review.
 */

import React from 'react';
import type { MatchSuggestion } from '../types';

export interface SuggestionsPanelProps {
  suggestions: MatchSuggestion[];
  onApply: (suggestion: MatchSuggestion) => void;
  onDismiss: (suggestion: MatchSuggestion) => void;
  theme?: 'light' | 'dark';
}

export const SuggestionsPanel: React.FC<SuggestionsPanelProps> = ({
  suggestions,
  onApply,
  onDismiss,
  theme = 'light'
}) => {
  if (suggestions.length === 0) return null;
  
  return (
    <div className={`suggestions-panel suggestions-panel--${theme}`}>
      <div className="suggestions-panel__header">
        <h4>💡 Suggested Mappings</h4>
        <span className="suggestions-panel__count">
          {suggestions.length} {suggestions.length === 1 ? 'suggestion' : 'suggestions'}
        </span>
      </div>
      
      <div className="suggestions-panel__list">
        {suggestions.map((suggestion, idx) => (
          <div key={idx} className="suggestion-item">
            <div className="suggestion-item__content">
              <div className="suggestion-item__fields">
                <span className="suggestion-item__source">{suggestion.sourceField}</span>
                <span className="suggestion-item__arrow">→</span>
                <span className="suggestion-item__target">{suggestion.targetField}</span>
              </div>
              
              <div className="suggestion-item__meta">
                <span className="suggestion-item__confidence">
                  {suggestion.confidence}% confidence
                </span>
                <span className="suggestion-item__reason">
                  {suggestion.reason}
                </span>
              </div>
            </div>
            
            <div className="suggestion-item__actions">
              <button
                className="suggestion-item__button suggestion-item__button--apply"
                onClick={() => onApply(suggestion)}
              >
                ✓ Apply
              </button>
              <button
                className="suggestion-item__button suggestion-item__button--dismiss"
                onClick={() => onDismiss(suggestion)}
              >
                ✕
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
